import React from 'react'

interface SideSheetProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
  width?: string
}

const SideSheet: React.FC<SideSheetProps> = ({ isOpen, onClose, children, width = '400px' }) => {
  if (!isOpen) return null

  return (
    <>
      {/* Overlay */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          backdropFilter: 'blur(4px)',
          zIndex: 1000,
          animation: 'fadeIn 0.3s ease-out'
        }}
        onClick={onClose}
      />

      {/* Side Sheet */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          width: 'min(100vw, ' + width + ')',
          backgroundColor: '#f8f9fa',
          boxShadow: '-4px 0 20px rgba(0, 0, 0, 0.15)',
          zIndex: 1001,
          animation: 'slideIn 0.3s ease-out',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column'
        }}
        className="responsive-sidesheet">
        {children}
      </div>

      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideIn {
          from {
            transform: translateX(100%);
          }
          to {
            transform: translateX(0);
          }
        }

        @media (max-width: 768px) {
          .responsive-sidesheet {
            width: 100vw !important;
            left: 0 !important;
            right: 0 !important;
          }
        }
      `}</style>
    </>
  )
}

export default SideSheet
